export default __webpack_public_path__ + "static/media/car3.28afe7cb.svg";